export default {
	billings: {
		title: '账单管理',
		bills: '账单',
		download_bill: '下载选中账单',
		shop_name: '店铺名称',
		billing_no: '账单编号',
		billing_name: '账单名称',
		billing_detail: '账单明细',
		price: '价格',
		pay_method: '支付方式',
		stauts: '状态',
		down_success: '下载成功',
		card: '月结虚拟卡',
		all_pay: '所有支付方式',
	},
}
